import { Reducer } from "redux";
import {
    AppointmentState,
    AppointmentActions,
    ConfirmAppointmentAction,
    ShowConfirmationSectionAction,
    StageAppointmentsAction
} from "./type";
import {
    confirmSelectedAppointmentHandler,
    showConfirmationModalHandler,
    stageAppointmentsHandler
} from "./handlers";
import {
    CONFIRM_APPOINTMENT,
    SHOW_CONFIRMATION_SECTION,
    STAGE_APPOINTMENTS
} from "./constants";
import { CategorizedAppointmentDataDto } from "../../dtos/KioskDtos.dtos";


/**
 * @name initialState
 * @type {AppointmentState}
 * @description Initial state of this part of the store.
 */
export const initialState: AppointmentState = {
    appointments: new CategorizedAppointmentDataDto(
        {
            lateAppointments: [],
            validAppointments: [],
            futureAppointments: []
        }),
    isAppointmentConfirmed: false,
    showConfirmationModal: false
};

/**
 * @name reducer
 * @constructs AppointmentState
 * @param {AppointmentState} state 
 * @param {AppointmentActions} action 
 */
const reducer: Reducer<AppointmentState> = (state: AppointmentState = initialState, action: AppointmentActions) => {
    switch ((action as AppointmentActions).type) {
        case CONFIRM_APPOINTMENT:
            return confirmSelectedAppointmentHandler(state, action as ConfirmAppointmentAction);

        case SHOW_CONFIRMATION_SECTION:
            return showConfirmationModalHandler(state, action as ShowConfirmationSectionAction);

        case STAGE_APPOINTMENTS:
            return stageAppointmentsHandler(state, action as StageAppointmentsAction);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Appointment/reducer.ts